export default [
  {
    featureType: "all",
    elementType: "all",
    stylers: [
      {
        visibility: "on",
      },
      {
        saturation: -35
      },
      {
        lightness:  10,
      },

    ],
  },
];
